module.exports = __webpack_public_path__ + "img/宣传_122.7e9ac3f6.jpg";